module.exports = __webpack_public_path__ + "img/magni.99533460.svg";